import { Component } from '@theme/component';

/**
 * Shared modal for Mom & Me shoppable looks.
 *
 * Clones `<template id="shoppable-look-content-{section.id}-{block.id}">` into
 * the modal before opening the dialog. Keys are scoped per block so the same
 * look metaobject can appear in multiple blocks or sections without ID clashes.
 *
 * Usage in Liquid:
 *   on:click="#mom-and-me-modal-{section.id}/openForLook/{section.id}-{block.id}"
 */
export class ShoppableLookModal extends Component {
  /**
   * @param {string} contentKey - Unique `{section.id}-{block.id}` for this grid block.
   */
  openForLook(contentKey) {
    const templateId = `shoppable-look-content-${contentKey}`;
    const sectionRoot = this.closest('mom-and-me-feed');
    const template =
      (sectionRoot instanceof HTMLElement &&
        sectionRoot.querySelector(`template#${CSS.escape(templateId)}`)) ||
      document.getElementById(templateId);

    if (!(template instanceof HTMLTemplateElement)) return;

    const content = this.querySelector('.shoppable-look-modal__inner');
    if (!content) return;

    content.replaceChildren(template.content.cloneNode(true));

    const dialogComponent = /** @type {import('./dialog.js').DialogComponent | null} */ (
      this.querySelector('dialog-component')
    );
    dialogComponent?.showDialog();
  }
}

if (!customElements.get('shoppable-look-modal')) {
  customElements.define('shoppable-look-modal', ShoppableLookModal);
}
